import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Figtree%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-figtree%22}],%22variableName%22:%22fontFigtree%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Figtree', 'Figtree Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
